import { render, staticRenderFns } from "./FormRF06.vue?vue&type=template&id=01cdaf05&scoped=true"
import script from "./FormRF06.vue?vue&type=script&lang=js"
export * from "./FormRF06.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cdaf05",
  null
  
)

export default component.exports